import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import XlsxPopulate from "xlsx-populate";
import { saveAs } from "file-saver";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";

// helpers
import {
  formateDateApi,
  formateDateandTime,
  formateDate,
  formateDateSemBarra,
} from "helpers/formats";

// services
import { api_POST } from "../../../services/api_service.js";
import { api_GET } from "../../../services/api_service.js";
import { showMessage } from "../../../services/message.js";

//Context
import { useAuth } from "../../../context/auth";

export default function RelatorioFichaRequerimentoGeradorRSS({ handleReturn }) {
  const { session, setLoading } = useAuth();

  const { register, handleSubmit, errors, setValue, clearErrors } = useForm({
    mode: "onBlur",
  });

  const [relatorio, set_relatorio] = useState(null);

  const [lista, set_lista] = useState(Object);

  // Tipo de Requerimento
  const [tipoRequerimento, set_tipoRequerimento] = React.useState("");
  const [subprefeitura, set_Subprefeitura] = React.useState([]);

  const [options_tipoRequerimento] = React.useState([
    { value: "Novo Cadastro", label: "Novo Cadastro" },
    { value: "Alteração", label: "Alteração" },
    { value: "Cancelamento", label: "Cancelamento" },
  ]);
  const handleTipoRequerimento = (value) => {
    set_tipoRequerimento(value);
    setValue("tipoRequerimento", value, true);
    clearErrors("tipoRequerimento");
  };

  const [options_subprefeitura, set_OptionsSubPrefeitura] = React.useState([]);
  const [showDetail, set_showDetail] = React.useState(false);

  const handleSubprefeitura = (value) => {
    set_Subprefeitura(value);
    setValue("subprefeitura", value, true);
  };

  useEffect(() => {
    api_GET("subprefeitura")
      .then((result) => set_OptionsSubPrefeitura(result.data))
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  }, []);

  const handleExcel = (data) => {
    set_showDetail(true);
  };

  const [filtro, set_filtro] = useState(null);

  const onSubmit = (data) => {
    // enviar um array de nomes, caso nao tenha nada sera atribuido um valor (Null) as subprefeituras;
    const validadacaoSubPrefeitura =
      subprefeitura && subprefeitura.length > 0
        ? subprefeitura.map((x) => x.nome)
        : null;

    let json_submit = {
      inicio: formateDateApi(data.dataInicial),
      fim: formateDateApi(data.dataFinal),
      acao: tipoRequerimento,
      subprefeitura: validadacaoSubPrefeitura,
    };

    setLoading(true);
    api_POST("relatorio/RelatorioRequerimentoGeradorRSS", json_submit)
      .then((result) => {
        json_submit.nome = session.nome;
        set_filtro(json_submit);
        set_relatorio(result.data);
      })
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (relatorio != null) {
      api_POST("relatorio/ExportToExcel", relatorio)
        .then((resultExcel) => set_lista(resultExcel.data))
        .catch((err) => showMessage("Aviso", err.message, "error", null))
        .finally(() => setLoading(false));
    }
  }, [relatorio]);

  const componentRef = React.useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    copyStyles: true,
  });

  //adicionar todas as subprefeituras ao clica no botao
  const handleTakeSubprefeituras = () => {
    set_Subprefeitura(options_subprefeitura);
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="6" className="noPrint">
            <Button color="Primary" onClick={handleReturn}>
              <i className="fas fa-chevron-left"></i> Voltar
            </Button>
          </Col>
          {relatorio != null && !showDetail && (
            <Col md="6" className="text-right noPrint">
              <Button color="danger" onClick={handlePrint}>
                <i className="fas fa-print"></i>
              </Button>
            </Col>
          )}
        </Row>
        {relatorio == null && (
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <Row>
                    <Col md="9">
                      <h4 className="mb-0 mt-0">
                        Requerimento de Geradores de RSS
                      </h4>
                      <label className="rel-subtitle">
                        Relatório detalhado de requerimentos de geradores de
                        RSS.
                      </label>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row className="noPrint">
                      <Col lg="4" md="4" sm="6">
                        <FormGroup>
                          <label className="form-control-label">
                            Data Inicial{" "}
                            <label className="text-danger">
                              (Data da última ação - Finalização)
                            </label>
                            :
                          </label>
                          <Input
                            className="form-control"
                            autocomplete="off"
                            type="date"
                            name="dataInicial"
                            innerRef={register({ required: true })}
                          />
                          {errors.dataInicial && (
                            <span className="form-control-label text-danger">
                              * Campo Obrigatório
                            </span>
                          )}
                        </FormGroup>
                      </Col>
                      <Col lg="4" md="4" sm="6">
                        <FormGroup>
                          <label className="form-control-label">
                            Data Final{" "}
                            <label className="text-danger">
                              (Data da última ação - Finalização)
                            </label>
                            :
                          </label>
                          <Input
                            className="form-control"
                            autocomplete="off"
                            type="date"
                            name="dataFinal"
                            innerRef={register({ required: true })}
                          />
                          {errors.dataFinal && (
                            <span className="form-control-label text-danger">
                              * Campo Obrigatório
                            </span>
                          )}
                        </FormGroup>
                      </Col>
                      <Col lg="4" md="4" sm="6">
                        <FormGroup>
                          <label className="form-control-label mt-1">
                            Tipo Requerimento:
                          </label>
                          <Select
                            options={options_tipoRequerimento}
                            name="tipoRequerimento"
                            onChange={(e) => {
                              handleTipoRequerimento(e.value);
                            }}
                            value={
                              tipoRequerimento != "" &&
                              options_tipoRequerimento.find(
                                (obj) => obj.value === tipoRequerimento
                              )
                            }
                            placeholder="Selecione"
                            ref={(e) =>
                              register(
                                { name: "tipoRequerimento" },
                                { required: true }
                              )
                            }
                          />
                          {errors.tipoRequerimento && (
                            <span className="form-control-label text-danger">
                              * Campo Obrigatório
                            </span>
                          )}
                        </FormGroup>
                      </Col>
                      <Col className="col-12">
                        <FormGroup>
                          <label className="form-control-label">
                            Regional / SubPrefeitura:
                          </label>
                          <Select
                            options={options_subprefeitura}
                            getOptionLabel={(option) => option.nome}
                            getOptionValue={(option) => option.subPrefeitura_Id}
                            name="subprefeitura"
                            onChange={(e) => {
                              handleSubprefeitura(e);
                            }}
                            value={subprefeitura}
                            placeholder="Selecione"
                            isMulti
                            ref={(e) =>
                              register(
                                { name: "subprefeitura" },
                                { required: false }
                              )
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="12">
                        <Button
                          color="sucess"
                          type="button"
                          className="btn btn-link"
                          onClick={handleTakeSubprefeituras}
                        >
                          Selecionar Todos
                        </Button>
                      </Col>
                      <Col lg="2" md="2" sm="12">
                        <Button
                          color="info"
                          className="btn-mobile"
                          type="submit"
                        >
                          {" "}
                          Gerar Relatório
                        </Button>
                      </Col>
                      <Col lg="2" md="2" sm="12">
                        <Button
                          color="danger"
                          className="btn-mobile"
                          type="submit"
                          onClick={() => handleExcel(relatorio)}
                        >
                          {" "}
                          Gerar Excel
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
        {!showDetail && relatorio && (
          <Row>
            <Col md="12">
              <Card>
                <CardBody>
                  <ComponentToPrint
                    relatorio={relatorio}
                    filtro={filtro}
                    ref={componentRef}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
        {showDetail && relatorio && lista.length > 0 && (
          <Row>
            <Col md="12">
              <ComponentToExcel
                relatorio={lista}
                filtro={filtro}
                ref={componentRef}
              />
            </Col>
          </Row>
        )}
      </div>
    </>
  );
}

export const ComponentToPrint = React.forwardRef((props, ref) => {
  const relatorio = props.relatorio;
  const filtro = props.filtro;
  return (
    <div ref={ref}>
      <div className="row">
        <div className="col-9">
          <h4 className="mb-0 mt-0">Requerimento de Geradores de RSS</h4>
          <label>
            Relatório detalhado de requerimentos de geradores de RSS.
          </label>
        </div>
        <div className="col-3 text-right">
          <label>Gerado em {formateDateandTime(new Date())}</label>
        </div>
      </div>
      {filtro != null && (
        <div className="row rel-filter">
          <div className="col-5">
            <span>
              <b>Período</b>
            </span>
            <br />
            <span>
              {formateDate(filtro.inicio) + " a " + formateDate(filtro.fim)}
            </span>
          </div>
          <div className="col-4">
            <span>
              <b>Gerado Por</b>
            </span>
            <br />
            <span>{filtro.nome}</span>
          </div>
          <div className="col-3">
            <span>
              <b>Tipo Requerimento</b>
            </span>
            <br />
            <span>{filtro.acao}</span>
          </div>
        </div>
      )}
      {relatorio != null &&
        relatorio.map((m, key) => (
          <div key={key}>
            <h5>
              <strong>{m.geradores.length > 0 ? m.subprefeitura : ""}</strong>
            </h5>
            {m.geradores.map((n, key2) => (
              <div className="rel-group" key={key2}>
                <div className="row rel-item">
                  <div className="col-12">
                    <span>
                      <b>Status: </b>
                    </span>
                    <span>{n?.statusRequerimento}</span>
                  </div>
                  <div className="col-12">
                    <span>
                      <b>Tipo: </b>
                    </span>
                    <span>{" " + n.tipo}</span>
                  </div>
                  <div className="col-3">
                    <span>
                      <b>Código: </b>
                    </span>
                    <span>{" " + n.codigo}</span>
                  </div>
                  <div className="col-6">
                    <span>
                      <b>Razão Social: </b>
                    </span>
                    <span>{" " + n.razaoSocial}</span>
                  </div>
                  <div className="col-3">
                    <span>
                      <b>CNPJ: </b>
                    </span>
                    <span>{" " + n.cnpj}</span>
                  </div>
                  <div className="col-3">
                    <span>
                      <b>CEP: </b>
                    </span>
                    <span>{" " + n.cep}</span>
                  </div>
                  <div className="col-6">
                    <span>
                      <b>Logradouro: </b>
                    </span>
                    <span>{" " + n.logradouro}</span>
                  </div>
                  <div className="col-3">
                    <span>
                      <b>Nº: </b>
                    </span>
                    <span>{" " + n.numero}</span>
                  </div>
                  <div className="col-3">
                    <span>
                      <b>Complemento: </b>
                    </span>
                    <span>{" " + n.complemento}</span>
                  </div>
                  <div className="col-6">
                    <span>
                      <b>Bairro: </b>
                    </span>
                    <span>{" " + n.bairro}</span>
                  </div>
                  <div className="col-3">
                    <span>
                      <b>Fone: </b>
                    </span>
                    <span>{" " + n.fone}</span>
                  </div>
                  <div className="col-3">
                    <span>
                      <b>Celular: </b>
                    </span>
                    <span>{" " + n.celular}</span>
                  </div>
                  <div className="col-6">
                    <span>
                      <b>Responsável Técnico: </b>
                    </span>
                    <span>{" " + n.responsavelTecnico}</span>
                  </div>
                  <div className="col-12">
                    <span>
                      <b>Data de Validação : </b>
                    </span>
                    <span>{" " + formateDate(n.dataValidacao)}</span>
                  </div>
                  <div className="col-6">
                    <span>
                      <b>Classificação: </b>
                    </span>
                    <span>{" " + n.classificacao}</span>
                  </div>
                  {n.locaisColeta.map((l, key3) => (
                    <div className="col-12" key={key3}>
                      <span>
                        <b>Local de Coleta: </b>
                      </span>
                      <span>
                        {" " +
                          l.logradouro +
                          ", " +
                          l.numero +
                          ", " +
                          l.complemento +
                          " - " +
                          l.bairro}
                      </span>
                    </div>
                  ))}
                  <div className="col-12">
                    <span>
                      <b>Locais de Armazenagem: </b>
                    </span>
                  </div>
                  {n?.locaisArmazenagem?.map((l, key4) => (
                    <div className="col-12" key={key4}>
                      <span>
                        {" " +
                          l.logradouro +
                          ", " +
                          l.numero +
                          ", " +
                          l.complemento +
                          " - " +
                          l.bairro}
                      </span>
                    </div>
                  ))}
                  {n.caracterizacaoResiduos.length > 0 && (
                    <>
                      <div className="col-12">
                        <span>
                          <b>Resíduos (Grupo / Código / Tipo): </b>
                        </span>
                      </div>
                      {n.caracterizacaoResiduos.map((c, key3) => (
                        <div className="col-12" key={key3}>
                          <span>
                            {" " + c.grupo + " / " + c.codigo + " / " + c.tipo}
                          </span>
                        </div>
                      ))}
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        ))}
    </div>
  );
});

export const ComponentToExcel = React.forwardRef((props, ref) => {
  const relatorio = props.relatorio;
  const filtro = props.filtro;

  const x = relatorio.map(function (val) {
    var array = Object.values(val);
    var columns = Object.keys(val);
    array.splice(14, 1);
    array.splice(14, 1);
    array.splice(15, 1);
    array[14] = formateDateSemBarra(array[14]);
    return array;
  });

  function getSheetData(data, header) {
    var fields = Object.keys(data[0]);
    var sheetData = data.map(function (row) {
      return fields.map(function (fieldName) {
        return row[fieldName] ? row[fieldName] : "";
      });
    });
    sheetData.unshift(header);
    return sheetData;
  }

  async function saveAsExcel() {
    let header = [
      "SubPrefeitura",
      "Tipo",
      "Código",
      "Razão Social",
      "CNPJ",
      "CEP",
      "Logradouro",
      "Nº",
      "Complemento",
      "Bairro",
      "Fone",
      "Celular",
      "Responsável Técnico",
      "Classificação",
      "Data de Validação",
      "Resíduos (Grupo / Código / Tipo)",
    ];

    XlsxPopulate.fromBlankAsync().then(async (workbook) => {
      const dia = new Date();
      const sheet1 = workbook.sheet(0).name("RSS");
      const sheetData = getSheetData(x, header);
      const totalColumns = sheetData[0].length;

      sheet1.cell("A1").value(sheetData);
      const range = sheet1.usedRange();
      const endColumn = String.fromCharCode(64 + totalColumns);
      sheet1.row(1).style("bold", true);
      sheet1.range("A1:" + endColumn + "1");
      return workbook.outputAsync().then((res) => {
        saveAs(
          res,
          "RelatorioRSS_" +
            dia.getDate() +
            (dia.getMonth() + 1) +
            dia.getFullYear() +
            ".xlsx"
        );
      });
    });
  }

  return (
    <>
      <Col md="12" className="text-right noPrint">
        <Button className="btn btn-info" onClick={saveAsExcel}>
          Exportar como XLS
        </Button>
      </Col>
      <Card className="card-stats">
        <CardBody>
          <div class="table-responsive">
            <table id="RSS_Excel" class="table">
              <thead>
                <tr>
                  <th>SubPrefeitura</th>
                  <th>Tipo</th>
                  <th>Código</th>
                  <th>Razão Social</th>
                  <th>CNPJ</th>
                  <th>CEP</th>
                  <th>Logradouro</th>
                  <th>Nº</th>
                  <th>Complemento</th>
                  <th>Bairro</th>
                  <th>Fone</th>
                  <th>Celular</th>
                  <th>Responsável Técnico</th>
                  <th>Data de Validação</th>
                  <th>Classificação</th>
                  <th>Resíduos (Grupo / Código / Tipo)</th>
                </tr>
              </thead>
              <tbody>
                {relatorio.map((item) => (
                  <tr>
                    <td>{item.subprefeitura}</td>
                    <td>{item.tipo}</td>
                    <td>{item.codigo}</td>
                    <td>{item.razaoSocial}</td>
                    <td>{item.cnpj}</td>
                    <td>{item.cep}</td>
                    <td>{item.logradouro}</td>
                    <td>{item.numero}</td>
                    <td>{item.complemento}</td>
                    <td>{item.bairro}</td>
                    <td>{item.fone}</td>
                    <td>{item.celular}</td>
                    <td>{item.responsavelTecnico}</td>
                    <td>{formateDateSemBarra(item.dataValidacao)}</td>
                    <td>{item.classificacao}</td>
                    <td>{item.caracterizacaoResiduos}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CardBody>
      </Card>
    </>
  );
});
